import { render, staticRenderFns } from "./Dataset.vue?vue&type=template&id=9e6c4da4&scoped=true"
import script from "./Dataset.vue?vue&type=script&lang=js"
export * from "./Dataset.vue?vue&type=script&lang=js"
import style0 from "./Dataset.vue?vue&type=style&index=0&id=9e6c4da4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e6c4da4",
  null
  
)

export default component.exports